import {routerReducer} from 'react-router-redux';
import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';

import season from './season';
import partner from './partner';
import stage from './stage';
import participant from './participant';
import post from './post';
import settings from './settings';
import admin from './admin';
import distance from './distance';
import results from './results';
import app from './app';
import images from './image';
import partnerCategories from './partnerCategories';
import promoCodes from './promo-codes';
import statistics from './statistics'

export default combineReducers({
    routing: routerReducer,
    form: formReducer,
    season,
    partner,
    stage,
    participant,
    post,
    settings,
    distance,
    app,
    results,
    statistics,
    images,
    partnerCategories,
    promoCodes,
    admin: combineReducers(admin)
});



// WEBPACK FOOTER //
// ./src/js/reducers/index.js